import { render, staticRenderFns } from "./SmsOperatorTariffZone.vue?vue&type=template&id=1f83a6d6&"
import script from "./SmsOperatorTariffZone.vue?vue&type=script&lang=ts&"
export * from "./SmsOperatorTariffZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports